import React from 'react';

import { StepperItem } from './StepperItem';
import { useTranslation } from 'react-i18next';
import { useAppSelector } from '../../hooks/hooksRedux';
import { RootState } from '../../store';
import { defaultColors } from '../../styles/style-guide';

interface Props extends React.InputHTMLAttributes<HTMLInputElement> {
  currentStep: number;
  maxSteps?: number;
}

const Stepper = ({ currentStep, maxSteps, ...rest }: Props) => {
  const MAX_STEPS = maxSteps || 6;
  const blocks: React.ReactElement[] = [];
  const { t } = useTranslation()
  const { colors } = useAppSelector((state: RootState) => state.styleGuide.data);
  const primaryColor = colors.primary || defaultColors.primary;

  for (let i = 1; i <= MAX_STEPS; i++) {
    blocks.push(
      <div
        key={i}
        style={{ backgroundColor: i <= currentStep ? primaryColor : '#E8E3FF' }}
        className="h-[14px] w-[56px] rounded-full"
      ></div>
    );
  }
  return (
    <div {...rest} className="flex flex-col gap-2">
      <div className="flex gap-4">{blocks}</div>
      <span className="font-medium">
        {currentStep} {t('others.othOfTable')} {blocks.length}
      </span>
    </div>
  );
};

export { Stepper, StepperItem };
